import React from 'react'
import { Route, Switch } from 'react-router-dom'
import NoMatch from './pages/NoMatch'
import PrivateRoute from './utils/PrivateRoute'
import Home from './pages/Home'
import Invoices from './pages/Invoices'
import LateSubmission from './pages/LateSubmission'
import SingleLateSubmission from './pages/LateSubmission/Single'
import CreateInvoice from './pages/Invoice'
import SingleInvoice from './pages/Invoice/Single'
import Submission from './pages/Invoice/Submission'
import UnAuthorized from './pages/UnAuthorized'
import Notifications from './pages/Notifications'
import Codes from './pages/Codes'
import InvoicePackages from './pages/InvoicePackages'
import Drafts from './pages/Invoices/Drafts'
import Templates from './pages/Invoices/Templates'

export const NamedRoutes = {
  home: '/',
  notifications: '/notifications',
  faqs: '/faqs',
  invoices: '/invoices',
  lateSubmission: '/late-submission',
  singleLateSubmission: '/late-submission/:id',
  singleInvoice: '/invoices/:id',
  msSingleInvoice: '/invoices/:id/e-invoice',
  newInvoice: '/invoices/new-invoice',
  submission: '/invoices/submissions/:id',
  msSubmission: '/invoices/submissions/:id/e-invoice',
  drafts: '/invoices/drafts',
  templates: '/invoices/templates',
  invoicePackages: '/invoice-packages',
  codes: '/codes-usages',
  unAuthorized: '/unauthorized'
}

export const Routes = () => {
  return (
    <Switch>
      <PrivateRoute exact path={NamedRoutes.home} component={Home}/>
      <PrivateRoute exact path={NamedRoutes.invoices} component={Invoices}/>
      <PrivateRoute exact path={NamedRoutes.drafts} component={Drafts}/>
      <PrivateRoute exact path={NamedRoutes.templates} component={Templates}/>
      <PrivateRoute exact path={NamedRoutes.newInvoice} component={CreateInvoice} checkSubscription checkQuota
                    redirectionRoute={NamedRoutes.invoices}/>
      <PrivateRoute exact path={NamedRoutes.singleInvoice} component={SingleInvoice} isMs={false} checkSubscription
                    redirectionRoute={NamedRoutes.invoices}/>
      
      <PrivateRoute exact path={NamedRoutes.singleLateSubmission} component={SingleLateSubmission}/>

      <PrivateRoute exact path={NamedRoutes.msSingleInvoice} component={SingleInvoice}  isMs={true} checkSubscription
                    redirectionRoute={NamedRoutes.invoices}/>

      <PrivateRoute exact path={NamedRoutes.submission} isMs={false} component={Submission} checkSubscription
                    redirectionRoute={NamedRoutes.invoices}/>

      <PrivateRoute exact path={NamedRoutes.msSubmission} isMs={true} component={Submission} checkSubscription
                    redirectionRoute={NamedRoutes.invoices}/>

      <PrivateRoute exact path={NamedRoutes.lateSubmission} component={LateSubmission}/>
      <PrivateRoute exact path={NamedRoutes.notifications} component={Notifications}/>
      <PrivateRoute exact path={NamedRoutes.codes} component={Codes}/>
      <PrivateRoute exact path={NamedRoutes.invoicePackages} component={InvoicePackages}/>
      <Route exact path={NamedRoutes.unAuthorized} component={UnAuthorized}/>
      <Route component={NoMatch}/>
    </Switch>
  )
}
